var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDespatchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_120_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 24.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.43 25.7281C34.512 25.3608 33.488 25.3608 32.57 25.7281L26.2373 28.2636C25.9314 28.3859 25.6691 28.597 25.4843 28.8697C25.2994 29.1424 25.2004 29.4642 25.2 29.7937V38.2043C25.2 38.5341 25.2988 38.8564 25.4837 39.1295C25.6686 39.4026 25.9311 39.6141 26.2373 39.7366L32.57 42.2699C33.488 42.6371 34.512 42.6371 35.43 42.2699L41.7627 39.7366C42.069 39.6141 42.3315 39.4026 42.5164 39.1295C42.7013 38.8564 42.8001 38.5341 42.8 38.2043V29.7937C42.7998 29.464 42.7009 29.142 42.5161 28.8691C42.3312 28.5961 42.0688 28.3849 41.7627 28.2625L35.43 25.7281ZM32.9792 26.7511C33.6349 26.4888 34.3663 26.4888 35.0219 26.7511L40.7694 29.0501L38.2625 30.0511L31.4931 27.3451L32.9781 26.7511H32.9792ZM30.0125 27.9358L36.7819 30.6429L34 31.7572L27.2306 29.049L30.0125 27.9369V27.9358ZM34.55 32.7208L41.7 29.8608V38.2032C41.7002 38.3132 41.6674 38.4207 41.6058 38.5119C41.5442 38.6031 41.4567 38.6737 41.3546 38.7147L35.0208 41.248C34.8668 41.3085 34.7095 41.3558 34.55 41.3888V32.7208ZM33.45 32.7208V41.3888C33.2892 41.3559 33.1316 41.3088 32.9792 41.248L26.6454 38.7147C26.5435 38.6738 26.4561 38.6033 26.3945 38.5124C26.333 38.4214 26.3 38.3141 26.3 38.2043V29.8619L33.45 32.7219V32.7208Z",
    fill: "#898989"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_120_2",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDespatchIcon);
export default __webpack_public_path__ + "static/media/despatch-icon.f2ac3076460bbb9f9fb09bced9e0d9aa.svg";
export { ForwardRef as ReactComponent };